import Indicator, { IndicatorType } from '../types/Indicator'

const BollingerBands: Indicator = {
  type: IndicatorType.OVERLAY,
  value: 'bollingerBands',
  label: 'Bollinger Bands',
  nickname: 'Bollinger Bands',
  fields: ['middle', 'upper', 'lower'],
  params: {
    field: 'close',
    period: 20,
    standardDeviations: 2,
  },
}

export default BollingerBands
